import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { HeaderCell } from './TableLightBackground';
import { RootState } from '../../redux/root';
import { dispatch } from '../../redux/store';
import { setTableCheckAllClicked, setTableSelectAll, setTableSelectedRows } from '../../redux/slices/generalSlice';

const TableLightHeaderCheckbox = ({ item, index }) => {
  const { tableSelectAll, tableSelectedRows } = useSelector((s: RootState) => s.general);

  useEffect(() => {
    const _selecedAll = tableSelectedRows.reduce((count, row) => {
      if (row.selected) {
        count++;
      }
      return count;
    }, 0);
    if (_selecedAll === tableSelectedRows.length && tableSelectedRows.length > 0) {
      dispatch(setTableSelectAll(true));
    }

    if (_selecedAll < tableSelectedRows.length) {
      dispatch(setTableSelectAll(false));
      dispatch(setTableCheckAllClicked(false));
    }
  }, [tableSelectedRows]);
  const onChange = e => {
    dispatch(setTableCheckAllClicked(true));
    dispatch(setTableSelectAll(e.target.checked));
  };
  return (
    <HeaderCell key={index}>
      <CheckboxInput type="checkbox" checked={tableSelectAll} onChange={onChange} />
      {item.title && <span>{item.title}</span>}
    </HeaderCell>
  );
};

export default TableLightHeaderCheckbox;

const CheckboxInput = styled.input`
  cursor: pointer;
  accent-color: var(--primary-600);
  width: 16px;
  height: 16px;
`;
